const QuestaoList = () => import("~/components/Views/Prova/Questao/List");
const QuestaoNew = () => import("~/components/Views/Prova/Questao/New");
const QuestaoView = () => import("~/components/Views/Prova/Questao/View");

import auth from "~/middleware/auth";
import grupoVerify from "~/middleware/grupoVerify";
import perfilVerify from "~/middleware/perfilVerify";

const breadcrumb = [
  { name: "Integrado", link: "http://on.grupointegrado.br/" },
  { name: "Prova", link: "" },
  { name: "Conteúdo", link: "" }
];

export const questao = [
  {
    path: "conteudo/questao",
    component: QuestaoList,
    name: "Questão",
    meta: {
      title: "Questão",
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "conteudo/questao/new",
    component: QuestaoNew,
    name: "Nova Questão",
    meta: {
      title: "Nova Questão",
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "conteudo/questao/:id",
    component: QuestaoNew,
    name: "Alterar Questão",
    meta: {
      title: "Alterar Questão",
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "conteudo/questao/view/:id/:grupoConteudoId?",
    component: QuestaoView,
    name: "Visualizar Questão",
    meta: {
      title: "Visualizar Questão",
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  }
];



// WEBPACK FOOTER //
// ./src/routes/prova/conteudo/questao.js